import React from 'react';
import PropTypes from 'prop-types';

const ImageManipulationControls = ({ reset, rotateImage }) => (
  <div className="mt2 col-sm-2">
    <button className="btn btn-link" onClick={rotateImage}>
      <i className="ss-refresh" />
      Rotate
    </button>
    <button className="btn btn-default mt2" onClick={reset}>
      Reset
    </button>
  </div>
);

ImageManipulationControls.propTypes = {
  reset: PropTypes.func.isRequired,
  rotateImage: PropTypes.func.isRequired
};

export default ImageManipulationControls;
